import React from 'react'

import { ApolloProvider } from '@apollo/client/react'
import { init } from '@sentry/browser'
import isPropValid from '@emotion/is-prop-valid'
import { I18nextProvider } from 'react-i18next'
import { StyleSheetManager } from 'styled-components'
import i18n from './i18n'

import { appConfig } from './config'
import { client } from './graphql/client'
import Router from './routing/Router'
import { ErrorBoundary } from './components/errorBoundary'

const shouldForwardProp = (propName, target) => (typeof target === 'string' ? isPropValid(propName) : true)

init({
	dsn: appConfig.sentryDsn,
	release: appConfig.buildString,
})

const App = () => (
	<ErrorBoundary>
		<ApolloProvider client={client}>
			<I18nextProvider i18n={i18n}>
				<StyleSheetManager shouldForwardProp={shouldForwardProp}>
					<Router />
				</StyleSheetManager>
			</I18nextProvider>
		</ApolloProvider>
	</ErrorBoundary>
)

export default App
